import styled from "styled-components";
import { typography, theme } from "dab-component-lib";
import { MediaStyle, basic } from "../../../utils/style-utils";

export const AbsoluteContainerStyle = styled.div`
  position: fixed;
  background-color: white;
  z-index: ${theme.zIndex.overthetop};
  height: 100vh;
  width: 100vw;
  right: 0;
  top: 0;
  ${MediaStyle.md`
    position: absolute;
    top: 60px;
    height: auto;
    width: auto;
    min-width: 320px;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.4);
  `}
`;

export const LoginPanelWrapperStyle = styled.div`
  & > div {
    height: 100vh;
    overflow-y: scroll;
    ${MediaStyle.md`
      height: auto;
      overflow: auto;
    `}
    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px;
      ${MediaStyle.md`
        padding: 15px;
    `}

      & > div {
        display: flex;
        flex-direction: column;
      }
    }
  }
  button {
    margin-bottom: 15px;
    ${MediaStyle.md`
        margin-bottom: 5px;
    `}
  }
  ${MediaStyle.md`
    h3 {
      height: 3px;
      div {
        display: none;
      }
    }
  `}
`;

export const UserPanelWrapperStyle = styled.div`
  height: 100vh;
  background: ${basic.greyGreen};
  & > div {
    background: white;
    height: 100vh;
    overflow-y: scroll;
    ${MediaStyle.md`
      height: auto;
      overflow: auto;
    `}
  }

  ${MediaStyle.md`
    height: auto;
    h3 {
      div {
        display: none;
      }
    }
  `}
`;

export const InLineContainerStyle = styled.div`
  border-bottom: ${(props) =>
    props.background ? "none" : `1px solid ${basic.greyGreen}`};
  background: ${(props) => props.background && `${basic.greyGreen}`};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 7px 20px;
`;

export const LabelStyle = styled.span`
  ${(props) => (props.bold ? typography.Body1 : typography.Body2)};
  color: ${basic.secondary};
`;



// WEBPACK FOOTER //
// ./src/components/common/userMenu/style.js